import React from 'react';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  fullWidth: {
    width: '100%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  fullHeight: {
    flex: 1,
    height: '100%',
  },
  center: {
    justifyContent: 'center',
  },
  right: {
    justifyContent: 'right',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  dontCenter: {
    alignItems: 'flex-start',
  },
  wrap: {
    flexWrap: 'wrap',
  }
}));

export const Row = (props) => {
  const { center, dontCenter, children, className, fullWidth, right, spaceBetween, fullHeight, wrap, ...rest } = props;

  const classes = styles();

  return (
    <div
      {...rest}
      className={clsx(classes.row, center && classes.center, dontCenter && classes.dontCenter, fullWidth && classes.fullWidth, fullHeight && classes.fullHeight, className, right && classes.right, spaceBetween && classes.spaceBetween, wrap && classes.wrap)}
    >
      {children}
    </div>
  );
};

export const Column = (props) => {
  const { center, children, className, fullHeight, fullWidth, ...rest } = props;

  const classes = styles();

  return (
    <div {...rest} className={clsx(classes.column, center ? classes.center : classes.dontCenter, fullWidth && classes.fullWidth, fullHeight && classes.fullHeight, className)}>
      {children}
    </div>
  );
};
